import React from 'react';

import Toggle from '../../scripts/modules/Toggle';

import Button from '../Button';

export default class ButtonToggle extends React.Component {
  static displayName = 'ButtonToggle';

  constructor(props) {
    super(props);
    this.trigger = React.createRef();
  }

  componentDidMount() {
    this.instance = new Toggle(this.trigger.current);
  }

  componentWillUnmount() {
    this.instance.destroy();
  }

  render() {
    const { children, ...other } = this.props;
    return (
      <Button elemRef={this.trigger} {...other}>
        {children}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/ButtonToggle.js